import gql from 'graphql-tag';
import { convertFilterRequestUrl } from 'utils/utils';

export default ({ page, size, filter, sort }) => {
  const sortStr = sort ? `, sort: ${sort}` : '';
  const filterStr = filter ? `, filter: ${convertFilterRequestUrl(filter, ['status'])}` : '';
  const searchOperatorInvoice = `searchOperatorInvoice(page: ${page}, size: ${size}${sortStr}${filterStr})`;
  return gql`
    query {
      ${searchOperatorInvoice} {
        id
        fileName
        billingDate
        processDate
        cutoffDate
        originOperator
        destinationOperator
        filePath
        numberOfBatch
        numberOfRecords
        status
        serviceType
    }
  }
  `;
};
